// extracted by mini-css-extract-plugin
export default {"TabContent":"TabContent_TabContent__BH2QX"};